import React from 'react';
import { useSelector } from 'react-redux';
import getCategoryFilters from 'store/category/selector/getCategoryFilters';
import { FilterAttributeGroup } from 'store/category/types';
import AttributeFilter from './AttributeFilter/AttributeFilter';
import styles from './ItemsFilter.module.scss';

const ItemsFilter = () => {
  const categoryFilter = useSelector(getCategoryFilters);

  return (
    <div className={styles.itemsFilter}>
      {categoryFilter?.attributeFilters?.map((attribute, index) => (
        <AttributeFilter key={`af${index}`} attribute={attribute} group={FilterAttributeGroup.attributeFilters} />
      ))}
      {categoryFilter?.tagFilters?.map((tag, index) => (
        <AttributeFilter key={`tf${index}`} attribute={tag} group={FilterAttributeGroup.tagFilters} />
      ))}
    </div>
  );
};

export default ItemsFilter;
